import {
  getCreditLineStatusChipType,
  getStatusChipColor,
} from 'lib/mobileDesignSystem';
import React, { createContext, useCallback, useContext, useState } from 'react';

export interface CreditLineOperationDetailContextValue {
  status: string | null;
  setOperationStatus: (status: string | null) => void;
  requestId: string | null;
  setRequestId: (id: string | null) => void;
}

const CreditLineOperationDetailContext =
  createContext<CreditLineOperationDetailContextValue | null>(null);

export const useCreditLineOperationDetail =
  (): CreditLineOperationDetailContextValue => {
    const ctx = useContext(CreditLineOperationDetailContext);
    if (ctx == null) {
      throw new Error(
        'useCreditLineOperationDetail must be used within CreditLineOperationDetailProvider',
      );
    }
    return ctx;
  };

export const getCreditLineStatusColor = (status: string): string => {
  const type = getCreditLineStatusChipType(status);
  return getStatusChipColor(type);
};

const APPROVAL_DISABLED_STATUSES = ['Revisada', 'No solicitada', 'Validando'];

export const isCreditLineApprovalEnabled = (status: string | null): boolean =>
  status != null && !APPROVAL_DISABLED_STATUSES.includes(status);

export const CreditLineOperationDetailProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [status, setOperationStatus] = useState<string | null>(null);
  const [requestId, setRequestId] = useState<string | null>(null);

  const value: CreditLineOperationDetailContextValue = {
    status,
    setOperationStatus: useCallback((s) => setOperationStatus(s), []),
    requestId,
    setRequestId: useCallback((id) => setRequestId(id), []),
  };

  return (
    <CreditLineOperationDetailContext.Provider value={value}>
      {children}
    </CreditLineOperationDetailContext.Provider>
  );
};
